import ActionTypes from '../action-types';

// navigation
export const onExpertReviewsAccordionClick = (isOpen: boolean,): object => ({
  type: ActionTypes.CLICK_EXPERT_REVIEWS_ACCORDION,
  data: {
    expertReviewPanel: { isOpen, },
  },
});

export const onExpertRatingsAccordionClick = (isOpen: boolean,): object => ({
  type: ActionTypes.CLICK_EXPERT_RATINGS_ACCORDION,
  data: {
    expertRatingPanel: { isOpen, },
  },
});

export const onConsumerReviewsAccordionClick = (isOpen: boolean,): object => ({
  type: ActionTypes.CLICK_CONSUMER_REVIEWS_ACCORDION,
  data: {
    consumerReviewPanel: { isOpen, },
  },
});

export const onConsumerRatingsAccordionClick = (isOpen: boolean,): object => ({
  type: ActionTypes.CLICK_CONSUMER_RATINGS_ACCORDION,
  data: {
    consumerRatingPanel: { isOpen, },
  },
});

export const onAwardsAccordionClick = (isOpen: boolean,): object => ({
  type: ActionTypes.CLICK_AWARDS_ACCORDION,
  data: {
    awardPanel: { isOpen, },
  },
});

export const dataReceived = (panelsWithData: string,): object => ({
  type: ActionTypes.DATA_RECEIVED,
  data: {
    panelsWithData,
  },
});

// Awards
export const onAwardsInfoClick = (): object => ({
  type: ActionTypes.CLICK_AWARDS_INFO,
});

// Expert Reviews
export const onExpertReviewsReadMoreClick = (): object => ({
  type: ActionTypes.CLICK_EXPERT_REVIEWS_READ_MORE,
});

// Consumer Reviews
export const onConsumerReviewsReadMoreClick = (): object => ({
  type: ActionTypes.CLICK_CONSUMER_REVIEWS_READ_MORE,
});

export const onConsumerReviewsMoreReviewsClick = (): object => ({
  type: ActionTypes.CLICK_CONSUMER_REVIEWS_MORE_REVIEWS,
});

// Footer
export const onFooterPrivacyLinkClick = (): object => ({
  type: ActionTypes.CLICK_FOOTER_PRIVACY_LINK,
});

export const onFooterReadMoreClick = (): object => ({
  type: ActionTypes.CLICK_FOOTER_READ_MORE,
});

export const openOverlay = (overlayHeader): object => ({
  type: ActionTypes.OPEN_GLOBAL_OVERLAY,
  data: {
    globalOverlay: {
      isOpen: true,
      overlayHeader
    }
  }
})

export const closeOverlay = (): object => ({
  type: ActionTypes.CLOSE_GLOBAL_OVERLAY,
  data: {
    globalOverlay: {
      isOpen: false,
      overlayHeader: ''
    }
  }
})
